export class Search
{
    searchstoreid: string;
    searchmerchantreference: string;       
    searchbasketid: string;
    searchfromdate: string;
    searchtodate: string;
    searchstatus: string;
    searchsmartcard:string;
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/searchmodel.ts